import React from 'react'
import { CardRow } from '../RequestItemCard/components';
import './PaymentStatusCard.scss'

interface PaymentStatusCardProps{
  paymentAmount: number
  paymentDate: string
  paymentReference: string
  paymentProcessed: string
  index: number
  paymentDescription: string
}

const PaymentStatusCard = (props: PaymentStatusCardProps) => (
  <div className="request-item-card">
    <h1 className="request-item-card__title">
      {`Payment ${props.index + 1}`}
    </h1>
    <CardRow label="Payment Reference" value={props.paymentReference} />
    <CardRow label="Payment Description" value={props.paymentDescription} />
    <CardRow label="Payment Date" value={props.paymentDate} />
    <CardRow label="Payment Amount" value={`AED ${props.paymentAmount}`} />
    <CardRow label="Payment Status" value={props.paymentProcessed} />
  </div>
)
export default PaymentStatusCard;
